/**
 * Performs a full-page navigation, as opposed to a Vue Router push.
 *
 * Wrapped in its own module for two reasons: it is the one place the SPA hands
 * control back to the server (login redirect, Cashier's 3D Secure screen), and
 * assigning `window.location.href` is unimplemented in jsdom, so tests need a
 * seam to assert against.
 */
export function navigateTo(url: string): void {
    window.location.href = url;
}
